export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = 4